export interface PositionComparisons {
  secIdentifier: PositionComparison<string>
  currency: PositionComparison<string>
  maturityDate: PositionComparison<Date, string>
  originalUnits: PositionComparison<number>
  currentUnits: PositionComparison<number>
  factor: PositionComparison<number>
  coupon: PositionComparison<number>
  accrued: PositionComparison<number>
  marketPrice: PositionComparison<number>
  pendingUnits: PositionComparison<number>
  marketValue: PositionComparison<number>
  positionStartDate: PositionComparison<Date, string>
  aggInfo: PositionComparison<string>
}

export interface PositionComparisonsExtToExt {
  secIdentifier: PositionComparisonExtToExt<string>
  currency: PositionComparisonExtToExt<string>
  maturityDate: PositionComparisonExtToExt<Date, string>
  originalUnits: PositionComparisonExtToExt<number>
  currentUnits: PositionComparisonExtToExt<number>
  factor: PositionComparisonExtToExt<number>
  coupon: PositionComparisonExtToExt<number>
  accrued: PositionComparisonExtToExt<number>
  marketPrice: PositionComparisonExtToExt<number>
  marketValue: PositionComparisonExtToExt<number>
  aggInfo: PositionComparisonExtToExt<string>
}

export interface PositionComparisonKeyToTitle {
  positionComparisonKey: keyof PositionComparisons | PositionComparisonsExtToExt
  displayTitle: string
}
export const PositionComparisonTitles: PositionComparisonKeyToTitle[] = [
  {
    positionComparisonKey: 'secIdentifier',
    displayTitle: 'Identifier',
  },
  {
    positionComparisonKey: 'currency',
    displayTitle: 'Currency',
  },
  {
    positionComparisonKey: 'maturityDate',
    displayTitle: 'Maturity Date',
  },
  {
    positionComparisonKey: 'originalUnits',
    displayTitle: 'Original Units',
  },
  {
    positionComparisonKey: 'currentUnits',
    displayTitle: 'Current Units',
  },
  {
    positionComparisonKey: 'factor',
    displayTitle: 'Factor',
  },
  {
    positionComparisonKey: 'coupon',
    displayTitle: 'Coupon',
  },
  {
    positionComparisonKey: 'accrued',
    displayTitle: 'Accrued',
  },
  {
    positionComparisonKey: 'marketPrice',
    displayTitle: 'Market Price',
  },
  {
    positionComparisonKey: 'pendingUnits',
    displayTitle: 'Pending Units',
  },
  {
    positionComparisonKey: 'marketValue',
    displayTitle: 'Market Value',
  },
  {
    positionComparisonKey: 'positionStartDate',
    displayTitle: 'Position Start Date',
  },
]

export interface PositionComparison<T, R = T> {
  extValue: T
  cwValue: T
  diff?: R
}

export interface PositionComparisonExtToExt<T, R = T> {
  extValueSelected: T
  extValueOtherDataSource: T
  diff?: R
}
